class MainNavigation {

  defaultConfig = {
    openBodyClass: 'main-navigation--open',
    toggleOpenClass: 'main-navigation__toggle--open',
    mobileScreenSizeLimit: 1023
  };

  constructor(config) {
    this.config = Object.assign({}, this.defaultConfig, config);
    this.storeDomElements();

    this.initToggle();
    this.initSubpageLinks();
  }

  storeDomElements() {
    this.domElements = {};
    this.domElements.body = $('body');
    this.domElements.document = $(document);
    this.domElements.toggle = this.config.toggleElement;
    this.domElements.navigation = this.config.navigationElement;

    this.domElements.subpageLinks = this.config.navigationElement.find('> li.has-subpages > a');
    return true;
  }

  initToggle() {
    this.domElements.toggle.on('click', () => {
      this.toggleNavigation();
    });
  }

  toggleNavigation() {
    if (this.domElements.toggle.hasClass(this.config.toggleOpenClass)) {
      this.closeNavigation();
    } else {
      this.openNavigation();
    }
  }

  openNavigation() {
    this.domElements.toggle.addClass(this.config.toggleOpenClass);
    this.domElements.toggle.attr('aria-expanded', true);
    this.domElements.body.addClass(this.config.openBodyClass);
    this.addKeyListener();
  }

  closeNavigation() {
    this.domElements.toggle.focus();
    this.domElements.toggle.removeClass(this.config.toggleOpenClass);
    this.domElements.toggle.attr('aria-expanded', false);
    this.domElements.body.removeClass(this.config.openBodyClass);
    this.removeKeyListener();
    this.removeClickListener();
  }

  addKeyListener() {
    this.domElements.document.on('keydown.hamburger-navigation', event => {
      if (event.key === 'Escape') {
        this.closeNavigation();
      }
    });
  }

  removeKeyListener() {
    this.domElements.document.off('keydown.hamburger-navigation');
  }

  initClickOutsideListener() {
    this.domElements.document.on('click.hamburger-navigation', event => {
      if (!$(event.target).closest(this.domElements.navigation).length &&
          !$(event.target).closest(this.domElements.toggle).length) {
        this.closeNavigation();
      }
    });
  }

  removeClickListener() {
    this.domElements.document.off('click.hamburger-navigation');
  }

  initSubpageLinks() {
    this.handleSubpageLinks();
    $(window).on('resize', this.handleSubpageLinks.bind(this));
  }

  handleSubpageLinks() {

    console.log('handleSubpageLinks');

    // if (window.innerWidth > this.config.mobileScreenSizeLimit) {
    //   this.domElements.subpageLinks.off('click.subpage-links');
    //   return true;
    // }

    this.domElements.subpageLinks.off('click.subpage-links');

    this.domElements.subpageLinks.on('click.subpage-links', (event) => {
      const link = $(event.currentTarget);
      const parentLi = link.parent();

      if (parentLi.hasClass('open')) {
        event.preventDefault();
        this.closeAllSubpageLinks();
        return false;
      } else {
        this.closeAllSubpageLinks();
        parentLi.addClass('open');
        return false;
      }
    });

  }

  closeAllSubpageLinks() {
    this.domElements.subpageLinks.parent().removeClass('open');
  }
}

export default MainNavigation;
